/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStrategyInfo,
    JsonStrategyInfoFromJSON,
    JsonStrategyInfoFromJSONTyped,
    JsonStrategyInfoToJSON,
} from './JsonStrategyInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStrategyInfo
 */
export interface ApiResultOfJsonStrategyInfo {
    /**
     * 
     * @type {JsonStrategyInfo}
     * @memberof ApiResultOfJsonStrategyInfo
     */
    data?: JsonStrategyInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStrategyInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStrategyInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStrategyInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStrategyInfo
     */
    result?: ApiResultOfJsonStrategyInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStrategyInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStrategyInfoFromJSON(json: any): ApiResultOfJsonStrategyInfo {
    return ApiResultOfJsonStrategyInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonStrategyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStrategyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStrategyInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStrategyInfoToJSON(value?: ApiResultOfJsonStrategyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStrategyInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

